import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import { useOrderOrigins } from 'src/pages/settings/settingsRequests';

export const useOrderOriginsTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const { rows, status, loading } = useOrderOrigins();
  const columns: GridColDef[] = useMemo(() => [
    { field: 'Id', headerName: 'Id' },
    { field: 'Name', headerName: 'Name', flex: 1 },
    { field: 'Description', headerName: 'Description', flex: 1 },
    { field: 'IsSystemDefined', headerName: 'Is System Defined', type: 'boolean' },
    { field: 'OrderChannelTypeId', headerName: 'Order Channel Type Id' },
    { field: 'SalesUnitId', headerName: 'Sales Unit Id' },
    { field: 'ExternalId', headerName: 'External Id' },
  ], []);
  const tableSettings = useTableSettings({ tableName: 'OrderOriginsTable', idPath: ['Id'], columns, rows, status });
  tableSettings.loading = loading;
  return [columns, tableSettings];
};
